import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/entity";
import CombineOperator from "@mapmycustomers/shared/types/viewModel/internalModel/CombineOperator";
import { MapFilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";
import PlatformFilterModel from "@mapmycustomers/shared/types/viewModel/platformModel/PlatformFilterModel";

import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";
import { createEmptyFilterModel } from "@app/util/filters/utils";
import {
  convertToPlatformFilterModel,
  filterCombineOperatorToPlatformCombineOperator,
} from "@app/util/viewModel/convertToPlatformFilterModel";

const convertMapFilterToPlatformFilterModel = (
  filter: MapFilterModel,
  visibleEntityTypes: EntityTypesSupportedByMapsPage[],
  combineOperator?: CombineOperator
): PlatformFilterModel => {
  const entitiesFilters = visibleEntityTypes.reduce((result, entityType) => {
    const fieldModel = getFieldModelByEntityType(entityType);
    return {
      ...result,
      [entityType]: {
        ...convertToPlatformFilterModel(
          filter[entityType] ?? createEmptyFilterModel(),
          fieldModel.fields.map((field) => ({ field, visible: true })),
          fieldModel
        ),
        includeGroups: true,
      },
    };
  }, {});

  const universalFilters = !filter.universal
    ? {}
    : convertToPlatformFilterModel(
        filter.universal || createEmptyFilterModel(),
        getFieldModelByEntityType("universal").fields.map((field) => ({ field, visible: true })),
        getFieldModelByEntityType("universal")
      );

  if (combineOperator) {
    return {
      ...universalFilters,
      [filterCombineOperatorToPlatformCombineOperator[combineOperator]]: [
        {
          ...(universalFilters.$and ? { $and: universalFilters.$and } : {}),
          ...(universalFilters.$or ? { $or: universalFilters.$or } : {}),
          ...(universalFilters.$not ? { $not: universalFilters.$not } : {}),
          entities: entitiesFilters,
        },
      ],
    };
  }

  return {
    ...universalFilters,
    entities: entitiesFilters,
  };
};

export default convertMapFilterToPlatformFilterModel;
